export default "__VITE_ASSET__voYkPJxG__"